module.exports = __webpack_public_path__ + "img/field-layout-1.9e05525e.jpg";